// src/client/utils.ts
import { generatePath, redirect } from "react-router-dom";
var utils = () => {
  return {
    redirect: (url, ...[options]) => {
      return redirect(options?.params ? generatePath(url, options.params) : url, options);
    }
  };
};

export {
  utils
};
